import {HTTPRepository} from 'rlink-repos/http';

const REPO_CACHE = {};

export default function getHttpRepo (contentRoot, contentMetaIndex, locale, appContentRegistry, useChecksumPaths) {
  if (!(locale in REPO_CACHE)) {
    REPO_CACHE[locale] = new HTTPRepository({
      contentRegistry: appContentRegistry,
      baseURL: contentRoot,
      contentMetaIndex,
      locale,
      useChecksumPaths,
    });
  }
  let repo = REPO_CACHE[locale];
  // httprepo has no no internal state so it's safe to just switch these up
  // we do not actually expect these to vary by more than locale
  repo.contentRegistry = appContentRegistry;
  repo.contentRoot = contentRoot;
  repo.contentMetaIndex = contentMetaIndex;
  repo.useChecksumPaths = useChecksumPaths;
  return repo;
}



// WEBPACK FOOTER //
// ./lib/rlink-repos/getHttpRepo.js